import { all } from 'redux-saga/effects'

import { submitSaga } from './submit/saga'

export function* savedSaga() {
  yield all([submitSaga()])
}
